import { create } from 'zustand'

interface ReconState {
  expandedRows: Set<string>
  toggleRow: (txnId: string) => void
  selectedIds: Set<string>
  toggleSelect: (txnId: string) => void
  setSelected: (ids: string[]) => void
  clearSelection: () => void
}

export const useReconStore = create<ReconState>((set) => ({
  expandedRows: new Set(),

  toggleRow: (txnId) =>
    set((state) => {
      const next = new Set(state.expandedRows)
      if (next.has(txnId)) {
        next.delete(txnId)
      } else {
        next.add(txnId)
      }
      return { expandedRows: next }
    }),

  selectedIds: new Set(),

  toggleSelect: (txnId) =>
    set((state) => {
      const next = new Set(state.selectedIds)
      if (next.has(txnId)) {
        next.delete(txnId)
      } else {
        next.add(txnId)
      }
      return { selectedIds: next }
    }),

  setSelected: (ids) => set({ selectedIds: new Set(ids) }),

  clearSelection: () => set({ selectedIds: new Set() }),
}))
